<!-- für Zahlentastatur: inputmode="numeric" - aber dann kann man keine , eingeben und auch kein - -->
<!--_{{randomGuid}}-->
<input #inputWriteable id="inputWriteable_{{randomGuid}}" [(ngModel)]="editValue" (focus)="focus()" (blur)="blur()" (keydown.enter)="$event.target.blur();"
(click)="$event.target.select()" [readonly]="false" 
[ngStyle]="ngStyle" 
[style.display]="showWriteable ? '' :'none'" 
type="text" pInputText 
oninput="onInput___funktioniert_so_nicht___wird_aus_AfterViewInit_gesetzt($event)" 
(change)="onChange()" [disabled]="disabled"
><!--[style.backgroundColor]="'green'"-->
<!-- type="number" step="1" -->
<!-- (keypress)="onKeyPress($event)"  -->
<!-- [style.textAlign]="'left'" -->
<!--_{{randomGuid}}-->
<input #inputFormatted id="inputFormatted_{{randomGuid}}" [readonly]="true" [value]="getFormatedValue()" pInputText 
class="p-input-filled"
[ngStyle]="ngStyle" 
[style.display]="showWriteable ? 'none' : ''" 
[style.color]="'black'"
>
<!--(focus)="switchToWriteable()"-->
